/***
 *
 *   TICKET DETAILS STYLES
 *   Header, context band, conversation scroll, composer — stacked in the main
 *   column with only the middle one scrolling. The rail is its own scroll from
 *   `lg` up and folds into the conversation scroll below that.
 *
 **********/

const Style = {
    shell: 'flex min-h-0 flex-1 flex-col overflow-hidden',
    loading: 'flex flex-1 items-center justify-center',
    spinner: 'h-8 w-8 animate-spin rounded-full border-2 border-primary-600 border-t-transparent',

    split: 'flex min-h-0 flex-1 lg:grid lg:grid-cols-[minmax(0,1fr)_20rem] xl:grid-cols-[minmax(0,1fr)_23rem]',

    mainCol: 'flex min-h-0 min-w-0 flex-1 flex-col lg:flex-auto',
    scroll: 'min-h-0 flex-1 overflow-y-auto',

    // The rail's contents, stacked into the conversation scroll on narrow
    // viewports where there is no room for a second column.
    railInline: 'space-y-3 px-4 py-4 sm:px-6 lg:hidden',
    rail: 'hidden min-h-0 space-y-3 overflow-y-auto border-l border-border bg-muted/20 px-4 py-4 lg:block',

    composer: 'shrink-0 border-t border-border bg-surface/60',
};

export default Style;
